import { SubNav } from '../components/SubNav.tsx';
import type { WorkflowSummary } from '../api.ts';
import { AnalyticsView } from './AnalyticsView.tsx';
import { ArtifactsView } from './ArtifactsView.tsx';
import { AssistantView } from './AssistantView.tsx';
import { AuditView } from './AuditView.tsx';
import { ContextGraphView } from './ContextGraphView.tsx';
import { FleetView } from './FleetView.tsx';
import { GoalsView } from './GoalsView.tsx';
import { PlatformView } from './PlatformView.tsx';

/**
 * The reports: how the factory is doing, and the platform it stands on.
 *
 * Eight sections that were eight rail buttons. None of them is something a
 * person does; each is something they look at, which is why they share a
 * screen and why it sits under Operate rather than beside the factory.
 */
export const INSIGHT_SECTIONS = [
  { id: 'analytics', label: 'Analytics' },
  { id: 'goals', label: 'Goals' },
  { id: 'fleet', label: 'Fleet' },
  { id: 'artifacts', label: 'Artifacts' },
  { id: 'audit', label: 'Audit' },
  { id: 'platform', label: 'Summary' },
  { id: 'context', label: 'Context graph' },
  { id: 'assistant', label: 'Assistant' },
] as const;

export function InsightsView({
  section,
  workflows,
  isAdmin,
  onSection,
}: {
  section: string;
  workflows: WorkflowSummary[];
  isAdmin: boolean;
  onSection(id: string): void;
}) {
  return (
    <div className="screen">
      <SubNav title="Insights" current={section} onChange={onSection} items={INSIGHT_SECTIONS} />
      {section === 'goals' ? (
        <GoalsView />
      ) : section === 'fleet' ? (
        <FleetView isAdmin={isAdmin} />
      ) : section === 'artifacts' ? (
        <ArtifactsView workflows={workflows} />
      ) : section === 'audit' ? (
        <AuditView workflows={workflows} />
      ) : section === 'platform' ? (
        <PlatformView />
      ) : section === 'context' ? (
        <ContextGraphView />
      ) : section === 'assistant' ? (
        <AssistantView />
      ) : (
        <AnalyticsView />
      )}
    </div>
  );
}
